import PropTypes from 'prop-types'
import { styles } from './styles'

export const boldText = 'No labels have been set up for this workspace yet.'
export const helpText =
  'Labels help to organize work and enable relevant views.'

export const NoLabelsMessage = ({ theme = 'dark' }) => (
  <p css={styles.message(theme)}>
    <strong>{boldText}</strong>
    <br /> {helpText}
  </p>
)

NoLabelsMessage.propTypes = {
  theme: PropTypes.oneOf(['light', 'dark']),
}
